import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import { useStaticQuery, graphql } from "gatsby"
import SetCookie from 'src/utils/SetCookie'
import CookieValue from 'src/utils/CookieValue'
import { navigate } from 'gatsby'

const FixedCta = () => {

    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
      window.addEventListener("scroll", function () {
        if (
          window.scrollY > 200 && window.scrollY + window.innerHeight < document.body.offsetHeight - 200
        ) {
          setScrolled(true)
        } else {
          setScrolled(false)
        }
      })
    })

    const { settings } = useStaticQuery(graphql`
      query GlobalBrochure {
        settings: storyblokEntry(field_component: {eq: "settings"}) {
          id
          content
        }
      }
    `)
    let parsedSetting = JSON.parse(settings.content)

    // Copied from SplitWithGalleryContent and modified for global borchure
    const downloadHistoryArray = `${CookieValue('download_history')}`.split(',')

    const SetCookies = () => {
      if (downloadHistoryArray.includes("Global Brochure")) {
        // Open the brochure in a new tab
        parsedSetting.global_brochure?.filename && window.open(parsedSetting.global_brochure?.filename, 'noopener,noreferrer')
      } else {
        SetCookie(`brochure_productname=${"Global Brochure"}`);
        SetCookie(`brochure_filename=${parsedSetting.global_brochure?.filename}`);
        navigate('/download-a-brochure/')
      }
    }

    return (
        <div className={`fixed bottom-0 w-full flex justify-center transition duration-300 z-50 ${scrolled ? "translate-y-0" : "translate-y-full"}`}>
            <div className={`bg-red rounded-t px-6`}>
                <Link className="inline-block font-display uppercase text-lg px-3 leading-[3em] text-white line-crop tracking-button transition duration-300 hover:opacity-50" to={`/get-in-touch/`}>Contact us</Link>
                <div
                  className="inline-block font-display uppercase text-lg px-3 leading-[3em] text-white line-crop tracking-button transition duration-300 hover:opacity-50 cursor-pointer"
                  onClick={SetCookies}
                  aria-hidden="true"
                >
                  Download a brochure
                </div>
            </div>
        </div>
    )
}

export default FixedCta